const a = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7%2034.53H33.29V40H7V34.53ZM14.82%2021.62H25.19L26.94%2027.12H32.69L24.93%204C24.18%201.78%2023.31%200%2020.34%200C17.37%200%2016.46%201.75%2015.68%204L7.56%2027.11H12.95L14.82%2021.62ZM20.08%206H20.21L23.7%2017H16.4L20.08%206Z'%20fill='%23EF3124'/%3e%3c/svg%3e";
export {
  a as default
};
